import { Suspense } from 'react';
import { useLoaderData, json, defer, Await } from 'react-router-dom';

import VendorIcons from '../components/VendorIcons.jsx';
import backend from '../util/backend.jsx';

function HomePage() {
  const { vendors } = useLoaderData();

  return (
    <>
      <h1 align="center">Background</h1>
      <p align="center">
        Services that meet the needs of our clients.
      </p>
      <Suspense fallback={<p style={{ textAlign: 'center' }}>Loading...</p>}>
        <Await resolve={vendors}>
          {(loadedVendors) => <VendorIcons vendors={loadedVendors} />}
        </Await>
      </Suspense>
    </>
  );
}

async function loadVendors() {
  const response = await fetch(`https://${backend}/vendorssummary`);

  if (!response.ok) {
    throw json(
      { message: 'Could not fetch vendors.' },
      {
        status: 500,
      }
    );
  } else {
    const resData = await response.json();
    return resData;
  }
}

export function loader() {
  return defer({
    vendors: loadVendors(),
  });
}

export default HomePage;
